module.exports = __webpack_public_path__ + "assets/images/pages/listarobinson/feature-2-icon-1.webp?91aedef3";